export const NEWSBOARD_POST_PROFILE_EDIT_MESSAGE_MODAL_QA_NAME =
  'newsboardPostProfileEditMessage'

export const NEWSBOARD_POST_PROFILE_EDIT_MESSAGE_MODAL_SUBMIT_QA_NAME = 'Save'
